<template>
	<div class="ticket-info-box" >
		<div class="ticket-info-content">
			<div class="ti-head">
				<label>{{vdata.Title}}</label>
				<i class="iconfont icon-close" @click="close"></i>
			</div>
			<div class="ti-pic"> 
				<Swipe style="height:5rem;" v-if="vdata.Imgs&&vdata.Imgs.length>0" :auto="6000">
                    <SwipeItem  v-for="img in vdata.Imgs" :key="img" :auto="6000">
                        <img :src="img" :alt="img" style="width:100%" />
                    </SwipeItem>
                </Swipe>
			</div>
            <div class="ti-info" style="padding-top: 0.5rem;">{{vdata.Info}}</div>
		</div>
	</div>
</template>
<script>
    const { Swipe, SwipeItem } = require('vue-swipe');//轮播图
	export default{
		name:'ticket-info',
        components:{
            Swipe,
            SwipeItem
        },
		props: {
	      	vdata: {
	        	type: Object,
	        	default: () => {
	          		return {}
	        	}
	      	}
	    },
	    data(){
	    	return{

	    	}
	    },
	    methods:{
	    	close(e){
	    		this.$emit('close')
	    	}
	    }
	}
</script>


// WEBPACK FOOTER //
// src/components/ticket/ticketDetail.vue